package com.klantenstop.web.data.models.dto.requests.curatedcity

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UpdateCuratedCity(
    val name: String? = null,
    val province: String? = null,
    val latitude: Double? = null,
    val longitude: Double? = null,
    val country: String? = null,
    @SerialName("is_featured")
    val isFeatured: Boolean? = null
) {
    val isValid get() = name != null || province != null || latitude != null || longitude != null || country != null || isFeatured != null
}
